import { useState } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { useSelector } from "react-redux";
import { ArrowLeft, BookOpen, Users } from "lucide-react";
import { useNavigate } from "react-router-dom";
import VirtualCourses from "../virtualCourses/VirtualCourses";
import { stripePromise } from "../../constants/constants";
import Tabs from "../tabs/Tabs";
import FilterSidebar from "../onTrackCourses/FilterSidebar";

const PartnerInstitutionCoursesPage = () => {
  const { currentJob, targetJob } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const [filters, setFilters] = useState({});

  const handleBack = () => {
    navigate("/dashboard/career-discovery/career-recommendations");
  };

  const handleFiltersChange = (newFilters) => {
    setFilters(newFilters);
  };

  const tabs = [
    {
      key: "ontrack-courses",
      label: "Ontrack Career Courses",
      icon: BookOpen,
      content: (
        <div className="text-center py-8">
          <p className="text-gray-600">Ontrack Career Courses content will be loaded here</p>
          <button 
            onClick={() => navigate("/dashboard/skills-and-learning/all-courses?courseTab=ontrack-courses")}
            className="mt-4 px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700"
          >
            View Ontrack Courses
          </button>
        </div>
      ),
    },
    {
      key: "partner-courses",
      label: "Partner Institution Courses",
      icon: Users,
      content: (
        <div>
          <Elements stripe={stripePromise}>
            <VirtualCourses type="partnerinstitution" filters={filters} />
          </Elements>
        </div>
      ),
    },
  ];

  return (
    <div className="min-h-screen">
      <div className="max-w-7xl mx-auto px-3">
        <div className="flex flex-col lg:flex-row gap-8">
          <div className="flex-1">
            <Tabs tabs={tabs} paramKey="courseTab" />
          </div>
          <div className="w-full mt-1 lg:w-64 flex-shrink-0">
            <FilterSidebar onFiltersChange={handleFiltersChange} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartnerInstitutionCoursesPage;
